export function supplant(str, o) {
  return str.replace(/{([^{}]*)}/g, (a, b) => {
    const r = o[b];
    return typeof r === 'string' || typeof r === 'number' ? r : a;
  });
}
